import { render, staticRenderFns } from "./multiPrice.vue?vue&type=template&id=a321d310&scoped=true&"
import script from "./multiPrice.vue?vue&type=script&lang=js&"
export * from "./multiPrice.vue?vue&type=script&lang=js&"
import style0 from "./multiPrice.vue?vue&type=style&index=0&id=a321d310&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a321d310",
  null
  
)

export default component.exports